/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, days: NonNullable<unknown> }} Artifact_Delete_Description_TrashInputs */



/**
* | output |
* | --- |
* | "Delete \"{name}\"? The app moves to the trash, where you can restore it for {days} days. Its share link and custom domain are switched off immediately and stay..." |
*
* @param {Artifact_Delete_Description_TrashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_delete_description_trash = /** @type {((inputs: Artifact_Delete_Description_TrashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Delete_Description_TrashInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" löschen? Die App wandert in den Papierkorb und lässt sich dort ${i?.days} Tage lang wiederherstellen. Ihr Freigabelink und ihre eigene Domain werden sofort abgeschaltet und bleiben auch nach dem Wiederherstellen aus.`)
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"? The app moves to the trash, where you can restore it for ${i?.days} days. Its share link and custom domain are switched off immediately and stay off after a restore.`)
});